<template>
    <span>
      <l-map style="height:100%;width:100%;z-index: 1" :zoom="zoom" :center="center" :bounds="bounds" :key="mapKey" ref="myMap">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker :key="i" v-for="(m , i) in markerLatLng" :lat-lng="m" v-if="markerLatLng != null">
            <l-icon :icon-url="markerIcon[i]" :icon-size="[35,45]"/>
        </l-marker>
        <l-polyline :lat-lngs="$store.getters.vehiclesRoutes" color="blue" :weight="weight" :opacity="opacity"></l-polyline>
      </l-map>
      <v-btn rounded class="over_mapTopData_top ml-2 primary--text" v-if="refocusButton" @click="refocusMap">
        <v-icon color="primary">navigation</v-icon> Refocus
      </v-btn>
    </span>
</template>

<script>

    import { latLng, icon, latLngBounds } from "leaflet";
    import {LMap, LTileLayer, LMarker, LIcon, LControlLayers,LPolyline} from 'vue2-leaflet';
    import busMoving from '../../assets/map/bus_moving.png'
    import busStopped from '../../assets/map/bus_stopped.png'
    import busStoppedEngineOff from '../../assets/map/bus_stopped_engine_off.png'


    export default {
        components: {
            LMap,LTileLayer,LMarker, LIcon, LControlLayers,LPolyline},
        name: "Map",
        data: () => ({
            markerIcon: null,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 15,
            center: [37.9924453, 23.7449098],
            markerLatLng: null,
            bounds: null,
            weight: 4,
            opacity: 0.7,
            refocusButton: false,
            currentZoom: 15,
            mapKey: 0
        }),

        methods: {

            addMarkerToMap(vehicle) {

                this.markerLatLng = [];
                this.markerIcon = [];

                if (vehicle.length > 0) {
                    let bound = []
                    for (var i = 0; i < vehicle.length; i++) {

                        this.markerLatLng.push(latLng(vehicle[i].Phi, vehicle[i].Lamda));
                        this.markerIcon.push(this.iconSelector(vehicle[i]));
                        bound.push([vehicle[i].Phi, vehicle[i].Lamda])
                        let vehiclesRoutes = this.$store.getters.vehiclesRoutes
                        vehiclesRoutes.push([vehicle[i].Phi, vehicle[i].Lamda]);
                        this.$store.commit('setVehiclesRoutes', vehiclesRoutes);
                    }

                    if (!this.refocusButton) {
                      this.bounds = latLngBounds([bound]);
                    }

                }

                // if (Object.keys(vehicle).length > 0) {
                //     this.iconSelector(vehicle);
                //     this.center = [vehicle.Phi, vehicle.Lamda];
                //     this.markerLatLng = latLng(vehicle.Phi, vehicle.Lamda)
                //     return
                // }
                // this.center = [37.9924453, 23.7449098];
                // this.markerLatLng = null
            },

            iconSelector(vehicle) {
              if (vehicle.statusColor == "blue") {
                return busMoving;
              } else if (vehicle.statusColor == "red") {
                  return busStoppedEngineOff
              } else {
                  return busStopped;
              }
            },

          handleZoomChange() {

            const map = this.$refs.myMap.mapObject;
            if (this.currentZoom == 15) {
              this.currentZoom = map.getZoom();
            }

            if (this.currentZoom != 15 && map.getZoom() != this.currentZoom) {
              this.refocusButton = true
            }
          },

          refocusMap() {
              this.refocusButton = false;
              this.mapKey++
              this.closeListener();
              this.openListener();
          },

          openListener() {
            this.$nextTick(() => {
              let map = this.$refs.myMap.mapObject;
              map.on('zoomend', this.handleZoomChange);
            });
          },

          closeListener() {
            const map = this.$refs.myMap.mapObject;
            if (map) {
              map.off('zoomend', this.handleZoomChange);
            }
          }
        },

        computed :{

            vehiclePosition: function () {
                return this.$store.getters.vehiclePosition
            }
        },

        watch: {

            'vehiclePosition': function (val) {

                this.addMarkerToMap(val);
            }
        },
        mounted() {
          this.openListener()
        },

        beforeDestroy() {
          this.closeListener()
        },
    }
</script>

<style scoped>

.over_mapTopData_top {
  border-color: red;
  border-style: solid;
  position: absolute;
  right: 10px;
  border-radius: 20px !important;
  text-align: center;
  bottom: 20px;
  z-index: 4;
}
</style>